import { get, patch, post } from './httpClient'

export const apiOrderPromotion = (object) => post('/order/order', object)
export const apiOrderVoucher = (body) => post('/order/add', body)
export const addOrder = (body) => post('/order/add', body)
export const updateOrder = (body, id) => patch('/order/update/' + id, body)
export const apiAllOrder = (query) => get('/order', query)
